function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M46.058,37.954V32.646A4.053,4.053,0,0,0,42.01,28.6h-.54v4.948a1.349,1.349,0,1,1-2.7,0v-7.2a1.349,1.349,0,1,0-2.7,0V28.6h-9v4.948a1.349,1.349,0,1,1-2.7,0v-7.2a1.349,1.349,0,1,0-2.7,0V28.6h-9v4.948a1.349,1.349,0,1,1-2.7,0v-7.2a1.349,1.349,0,1,0-2.7,0V28.6H4.048A4.053,4.053,0,0,0,0,32.646v5.307Z",
  transform: "translate(0 -25)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  d: "M0,199v21.86a4.053,4.053,0,0,0,4.048,4.048H42.01a4.053,4.053,0,0,0,4.048-4.048V199Zm12.954,18.711H10.075a1.349,1.349,0,0,1,0-2.7h2.879a1.349,1.349,0,0,1,0,2.7Zm0-5.757H10.075a1.349,1.349,0,0,1,0-2.7h2.879a1.349,1.349,0,0,1,0,2.7Zm0-5.757H10.075a1.349,1.349,0,0,1,0-2.7h2.879a1.349,1.349,0,0,1,0,2.7Zm11.515,11.514H21.59a1.349,1.349,0,1,1,0-2.7h2.879a1.349,1.349,0,1,1,0,2.7Zm0-5.757H21.59a1.349,1.349,0,1,1,0-2.7h2.879a1.349,1.349,0,1,1,0,2.7Zm0-5.757H21.59a1.349,1.349,0,0,1,0-2.7h2.879a1.349,1.349,0,0,1,0,2.7Zm11.515,11.514H33.1a1.349,1.349,0,0,1,0-2.7h2.879a1.349,1.349,0,1,1,0,2.7Zm0-5.757H33.1a1.349,1.349,0,0,1,0-2.7h2.879a1.349,1.349,0,1,1,0,2.7Zm0-5.757H33.1a1.349,1.349,0,0,1,0-2.7h2.879a1.349,1.349,0,0,1,0,2.7Z",
  transform: "translate(0 -183.347)"
});

const SvgIconAgenda = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46.058,
    height: 41.56,
    viewBox: "0 0 46.058 41.56",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAgenda, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Agenda.2ec7f24c.svg";
export { ForwardRef as ReactComponent };